<template>
  <div>
    <EasypostInvoicesHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <EasypostInvoicesFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <EasypostInvoicesTable
          :countFilterParams="countFilterParams"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
              @downloadFiles="type => $emit('downloadFiles', type)"
      />
    </div>
  </div>
</template>

<script>


  import EasypostInvoicesHead from "./EasypostInvoicesHead/EasypostInvoicesHead";
  import EasypostInvoicesFilter from "./EasypostInvoicesFilter/EasypostInvoicesFilter";
  import EasypostInvoicesTable from "./EasypostInvoicesTable/EasypostInvoicesTable";

  export default {
    name: "EasypostInvoicesTableAdmin",

    components: {
      EasypostInvoicesHead,
      EasypostInvoicesFilter,
      EasypostInvoicesTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
